import { Service } from "../classes/Service";

const service = new Service();

service.init();
